import { Link } from "react-router-dom";

export default function AdminNavigation() {
  return (
    <nav className="bg-slate-900 text-white">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
        <Link to="/cocofantoelefanto" className="flex items-center rtl:space-x-reverse hover:underline hover:bg-slate-800">Admin</Link>
        <div className="hidden w-full md:block md:w-auto" id="navbar-default">
          <ul id="admin-nav" className="font-medium flex flex-col md:flex-row md:space-x-8 rtl:space-x-reverse">
            <li className="hover:underline hover:bg-slate-800">
              <Link to="/cocofantoelefanto/teams">Equipes</Link>
            </li>
            <li className="hover:underline hover:bg-slate-800">
              <Link to="/cocofantoelefanto/tournaments">Tourneios</Link>
            </li>
            <li className="hover:underline hover:bg-slate-800">
              <Link to="/cocofantoelefanto/images">Imagens</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
